import { MembershipSummary, OrganisationSummary, User } from '../app/ApiGen';
import { membershipHasAttributes, organisationHasAttributes } from './format';
import { Normalised } from './request';

type MembershipWithOrganisation = Normalised<MembershipSummary> & { organisation: Normalised<OrganisationSummary> };

export function getMemberships(user: Normalised<User>): MembershipWithOrganisation[] {
  if (user.organisations.length === 0 || user.memberships.length === 0) {
    return [];
  }

  const organisations = user.organisations.flatMap((organisation) => {
    if (!organisationHasAttributes(organisation)) {
      return [];
    }
    return organisation;
  });

  const memberships = user.memberships.flatMap<MembershipWithOrganisation>((membership) => {
    if (!membershipHasAttributes(membership)) {
      return [];
    }
    const [organisationId] = membership.id.split('_');
    const organisation = organisations.find((o) => o.id === organisationId);
    if (!organisation || !organisationHasAttributes(organisation)) {
      return [];
    }
    return [{ ...membership, organisation }];
  });

  return memberships.sort((a, b) => a.organisation.name.localeCompare(b.organisation.name));
}
